/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ShieldSlash(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M227.87939,237.9209a8,8,0,0,1-11.30078-.541L187.4165,205.28613a147.318,147.318,0,0,1-54.44238,33.54492,15.49078,15.49078,0,0,1-9.94824,0c-15.2002-5.04-91.02637-34.71289-91.02637-124.16406V56a15.98851,15.98851,0,0,1,7.48242-13.52026L27.57861,29.37988a8,8,0,0,1,11.8418-10.75976l21.7998,23.99121.00879.00879L193.45654,188.13965l.01563.019,34.94824,38.46143A7.9992,7.9992,0,0,1,227.87939,237.9209Zm-28.2705-66.80274a8.00083,8.00083,0,0,0,13.208-2.07812c7.41993-16.376,11.18262-34.66992,11.18262-54.37305V56a16.01833,16.01833,0,0,0-16-16H98.54443a8.00019,8.00019,0,0,0-5.92089,13.37988Z" />
    </Svg>
  );
}

export default ShieldSlash;
